import React from 'react';
import {Typography} from "@mui/material";
import "./ContestPreviewHeader.style.scss"
import GlobalConst from "../../../constants/GlobalConst";

import {getTeamLogoUrl} from "../../../utils/SportUtils";
const ContestPreviewHeader = ({contest}) => {

    const player = contest.player;
    let playerPictureUrl = `${GlobalConst.CDN.BASEURL}images/Players/${player.League}/${player.PlayerId}.png`;
    const teamLogoUrl = getTeamLogoUrl(player.League, player.TeamId, `${player.League}Player`,null,null);


    return (
        <div className="ContestPreviewHeader">
            <div className="playerInfo">
                <div
                    alt="Player Image"
                    className="playerImage"
                    style={{backgroundImage: `url(${playerPictureUrl})`}}
                />
                <div className="playerDetails">
                    <Typography variant="h6" className="playerName">
                        {player.FirstName} {player.LastName}
                    </Typography>
                    <Typography variant="subtitle1" className="playerPosition">
                        {player.Position} | {player.TeamCityName} #{player.Jersey}
                    </Typography>
                </div>
            </div>
            <div alt="Logo"
                 className="teamLogo"
                 style={{backgroundImage: `url(${teamLogoUrl})`}}
            />
        </div>
    );
}

export default ContestPreviewHeader;